import { CancelTokenSource } from "axios";
import { InterventionOrderItem, InterventionOrderItemInstanceDto } from "ts-types/api.types";
import axios from "./http";

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/order-item`;

export const getOrderItemTemplateForIntervention = (
    interventionId: number,
    source: CancelTokenSource): Promise<InterventionOrderItem> => {

  return axios
      .get(`${apiUri}/intervention/${interventionId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getOrderItemForBooking = (
    bookingId: number,
    source: CancelTokenSource): Promise<InterventionOrderItemInstanceDto> => {

  return axios
      .get(`${apiUri}/booking/${bookingId}`, {cancelToken: source.token})
      .then(response => response.data);
};
